export enum BusinessCampaignCollab {
  CollabOnly = 0,
  CampaignOnly = 1,
  CollabAndCampaign = 2,
}
